var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWithText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000094604841396670779020000011150115548156130226_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 498.7 183.9",
    style: {
      enableBackground: "new 0 0 498.7 183.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#12174D;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 91.9,
    cy: 91.9,
    r: 91.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.9,34.5l72.4,72.4c3.4,3.4,3.4,9,0,12.4l0,0c-3.4,3.4-9,3.4-12.4,0L64.6,46.9c-3.4-3.4-3.4-9,0-12.4l0,0 C68,31.1,73.5,31.1,76.9,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.3,80.3l30.3,30.3c3.4,3.4,3.4,9,0,12.4l0,0c-3.4,3.4-9,3.4-12.4,0L60.9,92.7c-3.4-3.4-3.4-9,0-12.4l0,0 C64.3,76.9,69.9,76.9,73.3,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,119.6L64.3,119.6c3.4,3.4,3.4,8.9,0,12.3l-0.1,0.1c-3.4,3.4-8.9,3.4-12.3,0h0c-3.4-3.4-3.4-8.9,0-12.3 l0.1-0.1C55.4,116.2,60.9,116.2,64.3,119.6z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.8,68.9V56.5h58.1v12.3h-21.7v58.5h-14.8V68.9H215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.5,127.3V56.5h27.9c5.3,0,9.9,1,13.7,2.9s6.7,4.6,8.7,8.1c2,3.5,3,7.5,3,12.2c0,4.7-1,8.7-3,12.1 c-2,3.4-5,6-8.8,7.8c-3.8,1.8-8.5,2.7-13.9,2.7h-18.7v-12h16.3c2.9,0,5.2-0.4,7.1-1.2c1.9-0.8,3.3-2,4.2-3.5 c0.9-1.6,1.4-3.5,1.4-5.8c0-2.4-0.5-4.3-1.4-5.9c-0.9-1.6-2.4-2.8-4.3-3.7s-4.3-1.3-7.2-1.3h-10.1v58.6H283.5z M321.8,95.1 l17.6,32.2h-16.5l-17.2-32.2H321.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.4,56.5v70.8h-15V56.5H362.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.7,127.3V56.5h15v31.2h0.9l25.5-31.2H434l-26.3,31.7l26.6,39.1h-17.9l-19.4-29.1l-7.4,9v20.1H374.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.9,127.3V56.5h15V115h30.4v12.3H441.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logoWithText.795c84bee8b755f69e575ce20df412b2.svg";
export { ForwardRef as ReactComponent };